import React from 'react'
import {INavNotification} from '@api/user/account/notification/getNotification'
import {useTranslation} from '@lib/intl/useTranslations'
import useNavigation from '@hook/useNavigation'
import NotificationItemLayout from '@feature/account/components/notifications/NotificationListItem/layout/NotificationItemLayout'

interface INotificationItem extends INavNotification {}

const ProExpiredNotificationItem = (props: INotificationItem) => {
    const t = useTranslation()
    const {goAccountPro} = useNavigation()

    return (
        <NotificationItemLayout
            {...props}
            text={t(`globalNotification.NotificationItem.pro.expired`)}
            onClick={goAccountPro}
        />
    )
}

export default ProExpiredNotificationItem
